<template>
  <div class="sidebar-menu-container">
    <div class="logo">
      <img :src="banner"/>
    </div>
    <el-menu
      text-color="#fff"
      active-text-color="#fff"
      :default-active="activeIndex"
      class="el-menu-vertical"
      @open="handleOpen"
      @close="handleClose"
      :router="true"
      :collapse="isCollapse">
      <el-menu-item v-for="(item) in menus" :key="item.path" :index="item.path">
          <i :class="item.icon"></i>
          <span slot="title">{{item.title}}</span>
      </el-menu-item>
      <!-- <el-menu-item index="/order">
          <i class="el-icon-document"></i>
          <span slot="title">订单列表</span>
      </el-menu-item> -->
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import banner from '../../../assets/banner.png'

export default {
  name: 'Sider',
  data() {
    return {
      banner: banner,
      menus: [
        {title: '开始订舱', path: '/dashboard/book', icon: 'el-icon-menu'},
        {title: '订单列表', path: '/dashboard/order', icon: 'el-icon-document'},
        {title: '刷箱列表', path: '/dashboard/refresh', icon: 'el-icon-notebook-1'},
        {title: '已刷箱列表', path: '/dashboard/boxedList', icon: 'el-icon-notebook-2'}
      ],
      activeIndex: 0
    }
  },
  computed: {
    ...mapGetters([
      'isCollapse'
    ]),
    siderBarWidth() {
      return this.isCollapse
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        console.log('route =', route)
        this.activeIndex = route.fullPath
        console.log('activeIndex = ', this.fullPath)
      },
      immediate: true
    }
  },
  methods: {
    handleClose(key, keyPath) {
      // this.$store.commit('app/SET_IS_COLLAPSE', true)
    },
    handleOpen(key, keyPath) {
      console.log('key - ', key)
      console.log('keyPath - ', keyPath)
      // this.$store.commit('app/SET_IS_COLLAPSE', false)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.sidebar-menu-container {
  width: 200px;
  height: 100vh;
}
.logo {
  height: 54px;
  width: 100%;
  // width: 120px;
  // margin: auto 0 ;
  img {
    margin-top: 7px;
    height: 40px;
    width: 100%;
    object-fit: scale-down;
  }
}
.el-menu-vertical {
  width: 100%;
  // margin-top: 54px;
  height: calc(100% - 54px);
  background-color: #304156;
  .el-menu-item:focus, .el-menu-item:hover {
    background-color: #001528 !important;
  }
  .el-menu-item.is-active {
    background-color: #1f2d3d !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/Sider/index.vue